import React from 'react';
import PropTypes from 'prop-types';
import UsersTable from './UsersTable';

export default function MaintainUsers(props) {
  const { companyId, isReadOnly, customerType } = props;
  return (
    <div>
      <UsersTable companyId={companyId} isReadOnly={isReadOnly} customerType={customerType} />
    </div>
  );
}
MaintainUsers.propTypes = {
  companyId: PropTypes.string,
  isReadOnly: PropTypes.bool,
  customerType: PropTypes.number,
};
